export const slugify = (str) => str.split(" ").join("-");
